import { z } from "zod";

export type EventAttributesType = {
  id: number,
  event_id: number,
  smart_goals: string,
  seasonal_cultural: string,
  content_performance: string,
  event_hashtags: string,
  event_keywords: string,
  event_colors: string,
  event_tone: string,
  event_assets_description: string,
  event_name: string,
}

export type BrandAttributesType = {
  id: number,
  event_name: string,
  event_id: number,
  event_performance: string,
  keywords: string,
  content_pillars: string,
  hashtags: string,
  hooks: string
}

export type SocialPostType = {
  event_id: number,
  event: string;
  event_category: string,
  post_type: "Campaign" | "Post",
  priority: "High" | "Low",
  start_date: string,
  end_date: string,
  pending_posts_count: number,
  content: {
    post_id: number,
    post_content: string,
    post_date: string,
    post_time: string,
    tags: string[],
    image_video_recommendation: string,
    platform: string,
    image_url: string,
    catalogue: string
  }[]
}

export const PostBodyFormSchema = z.object({
  post_content: z.string().min(1, "Content is required"),
  post_id: z.number(),
  hashtags: z.array(z.string().min(1)),
  post_date: z.date(),
  post_time: z.string(),
  image_recommendation: z.string().min(1),
  catalogue: z.string().min(1)
})

export type PostBodyFormType = z.infer<typeof PostBodyFormSchema>;
